<style scoped lang="scss" type="text/scss">
    .player-container-wrapper {
        width: 100%;
    }
</style>

<template>
    <div class="player-container-wrapper">

<!--        <block-divider>领队指导教师</block-divider>-->
<!--        <teacher-leader :data="teacherLeader"></teacher-leader>-->

        <block-divider>指导教师（ 共 {{ teachers.length }} 位 ）</block-divider>
        <normal-teachers :data="teachers"></normal-teachers>

        <block-divider>学生队长</block-divider>
        <student-leader :data="studentLeader"></student-leader>

        <block-divider>学生队员（ 共 {{ students.length }} 位 ）</block-divider>
        <normal-students :data="students"></normal-students>

<!--        <block-divider>团队顾问（ 共 {{ consultants.length }} 位 ）</block-divider>-->
<!--        <consultants :data="consultants"></consultants>-->

        <block-divider>解说员（ 共 {{ narrators.length }} 位 ）</block-divider>
        <narrators :data="narrators"></narrators>

        <block-divider>裁判（ 共 {{ referees.length }} 位 ）</block-divider>
        <referees :data="referees"></referees>

        <block-divider>旗手（ 共 {{ flagBearers.length }} 位 ）</block-divider>
        <flag-bearers :data="flagBearers"></flag-bearers>

        <block-divider>参赛介绍</block-divider>
        <introduce :data="introduce"></introduce>

        <block-divider>机器人（ 共 {{ robots.length }} 个 ）</block-divider>
        <robots :data="robots"></robots>

        <block-divider>收件信息</block-divider>
        <consignee :data="consignee"></consignee>

        <block-divider>到场情况</block-divider>
        <present :data="present"></present>

        <block-divider>住宿信息（ 共 {{ accommodations.length }} 个 ）</block-divider>
        <accommodations :data="accommodations"></accommodations>

        <block-divider>总经费</block-divider>
        <funding :data="funding" :competition-name="competitionName"></funding>

        <block-divider>赞助信息（ 共 {{ sponsorships.length }} 个 ）</block-divider>
        <sponsorships :data="sponsorships"></sponsorships>

        <block-divider>单项赛报名情况（ 共 {{ specialCompetitions.length }} 个 ）</block-divider>
        <special-competitions :data="specialCompetitions"></special-competitions>

        <block-divider>合照</block-divider>
        <group-photos :data="groupPhoto"></group-photos>
    </div>
</template>

<script>
    import BlockDivider from '@/components/divider/block';
    import TeacherLeader from '@/pages/sub-components/player-information-collection/teacher-leader';
    import NormalTeachers from '@/pages/sub-components/player-information-collection/normal-teachers';
    import StudentLeader from '@/pages/sub-components/player-information-collection/student-leader';
    import NormalStudents from '@/pages/sub-components/player-information-collection/normal-students';
    import Consultants from '@/pages/sub-components/player-information-collection/consultants';
    import Narrators from '@/pages/sub-components/player-information-collection/narrators';
    import Referees from '@/pages/sub-components/player-information-collection/referees';
    import FlagBearers from '@/pages/sub-components/player-information-collection/flag-bearers';
    import Introduce from '@/pages/sub-components/player-information-collection/introduce';
    import Robots from '@/pages/sub-components/player-information-collection/robots';
    import Accommodations from '@/pages/sub-components/player-information-collection/accommodations';
    import Consignee from '@/pages/sub-components/player-information-collection/consignee';
    import Present from '@/pages/sub-components/player-information-collection/present';
    import Funding from '@/pages/sub-components/player-information-collection/funding';
    import Sponsorships from '@/pages/sub-components/player-information-collection/sponsorships';
    import SpecialCompetitions from '@/pages/sub-components/player-information-collection/special-competitions';
    import GroupPhotos from '@/pages/sub-components/player-information-collection/group-photos';
    import {mapState} from 'vuex';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            BlockDivider,
            TeacherLeader,
            NormalTeachers,
            StudentLeader,
            NormalStudents,
            Consultants,
            Narrators,
            Referees,
            FlagBearers,
            Introduce,
            Robots,
            Accommodations,
            Consignee,
            Present,
            Funding,
            Sponsorships,
            SpecialCompetitions,
            GroupPhotos
        },
        data () {
            return {};
        },
        computed: {
            ...mapState('player', {
                currentEnteredPlayerId: state => state.currentEnteredPlayerId,
                currentEnteredPlayerInfo: state => state.currentEnteredPlayerInfo,
                teacherLeader: state => state.currentEnteredPlayerTeacherLeader,
                studentLeader: state => state.currentEnteredPlayerStudentLeader,
                teachers: state => state.currentEnteredPlayerNormalTeachers,
                students: state => state.currentEnteredPlayerNormalStudents,
                consultants: state => state.currentEnteredPlayerConsultants,
                narrators: state => state.currentEnteredPlayerNarrators,
                referees: state => state.currentEnteredPlayerReferees,
                flagBearers: state => state.currentEnteredPlayerFlagBearers,
                robots: state => state.currentEnteredPlayerRobots,
                accommodations: state => state.currentEnteredPlayerAccommodations,
                sponsorships: state => state.currentEnteredPlayerSponsorships,
                specialCompetitions: state => state.currentEnteredPlayerSpecialCompetitions
            }),
            introduce () {
                return _.get(this.currentEnteredPlayerInfo, 'introduce', null);
            },
            consignee () {
                return _.get(this.currentEnteredPlayerInfo, 'player_consignee', null);
            },
            present () {
                return _.get(this.currentEnteredPlayerInfo, 'player_present', null);
            },
            funding () {
                return _.get(this.currentEnteredPlayerInfo, 'funding', null);
            },
            groupPhoto () {
                return _.get(this.currentEnteredPlayerInfo, 'group_photo', null);
            },
            competitionName () {
                return _.get(this.currentEnteredPlayerInfo, 'competition_name', null);
            }
        },
        watch: {
            currentEnteredPlayerId: {
                immediate: true,
                handler (currentEnteredPlayerId) {
                    if (currentEnteredPlayerId === null || currentEnteredPlayerId === undefined) return;
                    this.$normalRequest('player/loadEnteredPlayerInfoPackage', {
                        id: this.currentEnteredPlayerId
                    }, false, false, this, 'requesting').then();
                }
            }
        }
    };
</script>
